export const AttractSubCategories = [10, 1, 251459, 251613, 251521, 251522, 21, 251481, 251614, 6, 27, 22, 251545, 34];
export const BuildSubCategories = [251470, 53, 251471, 52, 107, 110, 106, 62, 149, 251697, 108, 79, 251478, 251546, 51, 78, 50, 70, 251519, 251611, 55, 66, 251379, 59, 114, 251520, 251466, 251660, 251469, 20];
export const ConnectSubCategories = [251540, 251533, 251482, 251537, 251539, 251538, 12, 61];
export const ControlSubCategories = [251490, 251616, 251491, 251615, 133, 251602, 251498, 251487, 101, 105, 251500, 251511, 98, 251484, 251489, 14, 251493, 251654, 251548, 251486, 251497, 28, 251496, 251499, 251549, 97, 251507, 251488];
export const OrganizeSubCategories = [251547, 251556, 251558, 72, 251555];
export const ResolveSubCategories = [251554, 80, 3, 113, 2, 251605, 5, 251468, 109, 4, 91, 251698, 75];
export const subCategoryToFeatureIdsMap = {
  ATTRACT: Object.values(AttractSubCategories),
  BUILD: Object.values(BuildSubCategories),
  CONNECT: Object.values(ConnectSubCategories),
  CONTROL: Object.values(ControlSubCategories),
  ORGANIZE: Object.values(OrganizeSubCategories),
  RESOLVE: Object.values(ResolveSubCategories)
};